(() => {
  'use strict';
  const configElement = document.getElementById('ms-commerce-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const strings = config.strings;
  const drawer = document.getElementById('ms-cart-drawer');
  const root = (window.Shopify?.routes?.root || config.routes.root).replace(/\/?$/, '/');
  let cart = config.cart;
  let busy = false;
  let revision = 0;
  let arrivalTimer;
  let pulseTimer;
  const currency = () => cart?.currency?.iso_code || cart?.currency || config.currency;
  const money = value => new Intl.NumberFormat(config.locale || 'en-GB', {style: 'currency', currency: currency()}).format(Number(value || 0) / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character]));
  const icon = (name, size = 20) => {
    const paths = {plus: '<path d="M12 5v14M5 12h14"/>', minus: '<path d="M5 12h14"/>', arrow: '<path d="M5 12h14m-6-6 6 6-6 6"/>', bag: '<path d="M5 7h14l1 14H4L5 7Zm3 0V6a4 4 0 0 1 8 0v1"/>'};
    return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name] || paths.arrow}</svg>`;
  };
  const imageUrl = (source, width = 180) => {
    if (!source) return '';
    try {
      const url = new URL(source, location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      url.searchParams.set('width', String(width));
      return url.href;
    } catch { return ''; }
  };
  const openDialog = dialog => {
    if (!dialog) return;
    if (window.MSDialogs) window.MSDialogs.open(dialog);
    else if (!dialog.open) dialog.showModal();
  };
  const closeDialog = dialog => {
    if (!dialog?.open) return;
    if (window.MSDialogs) window.MSDialogs.close(dialog);
    else dialog.close();
  };
  const bagError = text => { drawer.querySelector('[data-ms-bag-error]').textContent = text || ''; };
  const setBusy = value => {
    busy = value;
    drawer.querySelector('[data-ms-bag-content]').setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-ms-cart-change], [data-ms-discount-form] button, [data-ms-checkout]').forEach(button => { button.disabled = value; });
    document.querySelectorAll('[data-ms-add-button]').forEach(button => {
      const form = button.closest('[data-ms-buy-controls]');
      button.disabled = value || form?.dataset.msVariantAvailable === 'false';
      const label = button.querySelector('[data-ms-add-label]');
      if (label) label.textContent = value ? strings.updating : form?.dataset.msVariantAvailable === 'false' ? strings.soldOut : strings.add;
    });
  };
  async function request(path, body) {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Accept': 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})}, ...(body ? {body: JSON.stringify(body)} : {}), cache: 'no-store'});
    let result;
    try { result = await response.json(); } catch { throw new Error(strings.updateFailed); }
    if (!response.ok || result.status >= 400) {
      const message = typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : strings.updateFailed;
      throw new Error(message);
    }
    return result;
  }
  const optionsText = item => item.product_has_only_default_variant ? '' : (item.options_with_values || []).filter(option => option.value !== 'Default Title').map(option => `${option.name}: ${option.value}`).join(' / ');
  function renderCart(next, arrivingKey) {
    cart = next;
    const count = Number(cart.item_count) || 0;
    document.querySelectorAll('[data-ms-cart-count]').forEach(element => { element.textContent = String(count); });
    document.querySelectorAll('[data-ms-cart-open]').forEach(element => { element.setAttribute('aria-label', `${strings.bagLabel}, ${count}`); });
    drawer.querySelector('[data-ms-bag-total]').textContent = String(count);
    drawer.querySelector('[data-ms-bag-subtotal]').textContent = money(cart.total_price);
    drawer.querySelector('[data-ms-bag-checkout]').hidden = count === 0;
    drawer.querySelector('[data-ms-bag-retry]').hidden = true;
    const content = drawer.querySelector('[data-ms-bag-content]');
    if (!cart.items?.length) {
      content.innerHTML = `<div class="empty-bag">${icon('bag', 40)}<h3>${escape(strings.empty)}</h3><a href="${escape(config.routes.collection)}">${escape(strings.explore)}${icon('arrow')}</a></div>`;
    } else {
      content.innerHTML = cart.items.map(item => {
        const source = imageUrl(item.featured_image?.url || item.image);
        const quantity = Number(item.quantity);
        const discounts = (item.line_level_discount_allocations || []).map(discount => `<p class="ms-line-discount">${escape(discount.discount_application.title)} (−${escape(money(discount.amount))})</p>`).join('');
        const properties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value).map(([key, value]) => `<p>${escape(key)}: ${escape(value)}</p>`).join('');
        const sellingPlan = item.selling_plan_allocation?.selling_plan?.name;
        return `<article class="bag-line" data-ms-line-key="${escape(item.key)}" data-arriving="${item.key === arrivingKey}"><a href="${escape(item.url)}">${source ? `<img src="${escape(source)}" alt="${escape(item.product_title)}" width="95" height="119">` : ''}</a><div><a href="${escape(item.url)}">${escape(item.product_title)}</a><p>${escape(optionsText(item))}</p>${sellingPlan ? `<p>${escape(sellingPlan)}</p>` : ''}${properties}<strong>${escape(money(item.final_line_price))}</strong>${discounts}<div class="quantity"><button type="button" data-ms-cart-change="${escape(item.key)}" data-ms-quantity="${Math.max(0, quantity - 1)}" data-ms-control="reduce" aria-label="${escape(strings.reduce + ' ' + item.product_title)}">${icon('minus', 14)}</button><span aria-label="${escape(strings.quantity)}">${quantity}</span><button type="button" data-ms-cart-change="${escape(item.key)}" data-ms-quantity="${quantity + 1}" data-ms-control="increase" aria-label="${escape(strings.increase + ' ' + item.product_title)}">${icon('plus', 14)}</button><button class="remove-line" type="button" data-ms-cart-change="${escape(item.key)}" data-ms-quantity="0" data-ms-control="remove">${escape(strings.remove)}</button></div></div></article>`;
      }).join('');
    }
    const applications = cart.cart_level_discount_applications || [];
    drawer.querySelector('[data-ms-discounts]').innerHTML = applications.map(discount => `<small>${escape(discount.title)} (−${escape(money(discount.total_allocated_amount))})</small>`).join('');
    document.dispatchEvent(new CustomEvent('ms:cart-updated', {detail: {cart}}));
  }
  function clearArrival() {
    clearTimeout(arrivalTimer);
    drawer.querySelector('[data-ms-bag-announcement]').replaceChildren();
    drawer.querySelectorAll('[data-arriving]').forEach(element => { element.dataset.arriving = 'false'; });
  }
  function announceArrival(item) {
    clearArrival();
    const source = imageUrl(item.featured_image?.url || item.image);
    drawer.querySelector('[data-ms-bag-announcement]').innerHTML = `<div class="bag-arrival"><div class="bag-arrival-image" aria-hidden="true">${source ? `<img src="${escape(source)}" alt="" width="64" height="80">` : icon('bag', 32)}</div><div><span class="bag-arrival-label">${escape(strings.added)}</span><p>${escape(item.product_title)}</p><small>${escape(optionsText(item) || strings.piece)}</small></div><svg class="bag-arrival-check" viewBox="0 0 28 28" aria-hidden="true"><circle cx="14" cy="14" r="12"/><path d="m8 14 4 4 8-8"/></svg></div>`;
    drawer.querySelectorAll('[data-ms-line-key]').forEach(element => { element.dataset.arriving = String(element.dataset.msLineKey === item.key); });
    clearTimeout(pulseTimer);
    document.querySelectorAll('[data-ms-bag-icon], [data-ms-cart-count]').forEach(element => {
      const className = element.matches('[data-ms-bag-icon]') ? 'bag-icon-arrived' : 'bag-count-arrived';
      element.classList.remove(className);
      void element.offsetWidth;
      element.classList.add(className);
    });
    pulseTimer = setTimeout(() => document.querySelectorAll('.bag-icon-arrived,.bag-count-arrived').forEach(element => element.classList.remove('bag-icon-arrived', 'bag-count-arrived')), 1000);
    arrivalTimer = setTimeout(clearArrival, 5000);
  }
  async function loadBag() {
    if (busy) return;
    const currentRevision = ++revision;
    try {
      const next = await request('cart.js');
      if (revision !== currentRevision) return;
      renderCart(next);
      bagError('');
    } catch {
      if (revision !== currentRevision) return;
      bagError(strings.loadFailed);
      drawer.querySelector('[data-ms-bag-retry]').hidden = false;
    }
  }
  async function addProduct(form) {
    if (busy || !form.reportValidity()) return;
    const controls = form.closest('[data-ms-buy-controls]');
    const error = controls.querySelector('[data-ms-product-error]');
    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    if (!variantId || controls.dataset.msVariantAvailable === 'false') { error.textContent = strings.choose; return; }
    revision++;
    setBusy(true);
    error.textContent = '';
    bagError('');
    clearArrival();
    try {
      const before = await request('cart.js');
      const beforeQuantity = (before.items || []).filter(item => Number(item.variant_id) === variantId).reduce((total, item) => total + item.quantity, 0);
      const item = {id: variantId, quantity: Number(formData.get('quantity')) || 1};
      const properties = {};
      for (const [name, value] of formData) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) item.properties = properties;
      if (formData.get('selling_plan')) item.selling_plan = formData.get('selling_plan');
      await request('cart/add.js', {items: [item]});
      const after = await request('cart.js');
      const matching = (after.items || []).filter(line => Number(line.variant_id) === variantId);
      const afterQuantity = matching.reduce((total, line) => total + line.quantity, 0);
      renderCart(after);
      if (afterQuantity <= beforeQuantity) throw new Error(strings.addFailed);
      const addedLine = matching.find(line => (before.items || []).find(old => old.key === line.key)?.quantity < line.quantity) || matching.find(line => !(before.items || []).some(old => old.key === line.key)) || matching[0];
      closeDialog(form.closest('dialog'));
      openDialog(drawer);
      announceArrival(addedLine);
    } catch (failure) {
      error.textContent = failure.message || strings.addFailed;
      try { renderCart(await request('cart.js')); } catch { bagError(strings.loadFailed); }
    } finally { setBusy(false); }
  }
  async function changeQuantity(button) {
    if (busy) return;
    const key = button.dataset.msCartChange;
    const quantity = Number(button.dataset.msQuantity);
    const control = button.dataset.msControl;
    if (!key || !Number.isInteger(quantity) || quantity < 0) return;
    revision++;
    setBusy(true);
    bagError('');
    clearArrival();
    try {
      renderCart(await request('cart/change.js', {id: key, quantity}));
      const replacement = [...drawer.querySelectorAll('[data-ms-cart-change]')].find(element => element.dataset.msCartChange === key && element.dataset.msControl === control);
      setBusy(false);
      (replacement || drawer.querySelector('[data-ms-dialog-close]')).focus({preventScroll: true});
    } catch (failure) { bagError(failure.message || strings.updateFailed); }
    finally { setBusy(false); }
  }
  async function applyDiscount(form) {
    if (busy) return;
    const code = String(new FormData(form).get('discount') || '').trim();
    revision++;
    setBusy(true);
    bagError('');
    try {
      const next = await request('cart/update.js', {discount: code});
      renderCart(next);
      const codes = next.discount_codes || [];
      const discount = codes.find(item => String(item.code).toLowerCase() === code.toLowerCase());
      const applications = [...(next.cart_level_discount_applications || []), ...(next.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
      const applied = discount?.applicable === true || applications.some(item => String(item.title).toLowerCase() === code.toLowerCase());
      const result = document.createElement('small');
      result.textContent = !code ? strings.discountRemoved : `${code}: ${applied ? strings.discountApplied : strings.discountUnconfirmed}`;
      drawer.querySelector('[data-ms-discounts]').append(result);
    } catch (failure) { bagError(failure.message || strings.updateFailed); }
    finally { setBusy(false); }
  }
  function initializeProducts(scope = document) {
    scope.querySelectorAll('[data-ms-buy-controls]').forEach(controls => {
      if (controls.dataset.msInitialized) return;
      let variants;
      try { variants = JSON.parse(controls.querySelector('[data-ms-variants]').textContent); } catch { return; }
      const select = controls.querySelector('[data-ms-variant-select]');
      const pickers = controls.querySelector('[data-ms-option-pickers]');
      const selected = variants.find(variant => String(variant.id) === select.value) || variants.find(variant => variant.available) || variants[0];
      if (!selected) return;
      let options = [...selected.options];
      controls.dataset.msInitialized = 'true';
      const refresh = (updateURL = false) => {
        const variant = variants.find(candidate => candidate.options.every((value, index) => value === options[index]));
        select.value = variant ? String(variant.id) : '';
        controls.dataset.msVariantAvailable = String(Boolean(variant?.available));
        controls.querySelectorAll('[data-ms-option-position]').forEach(fieldset => {
          const position = Number(fieldset.dataset.msOptionPosition);
          fieldset.querySelector('[data-ms-selected-option]').textContent = options[position] ? ` / ${options[position]}` : '';
          fieldset.querySelectorAll('[data-ms-option-value]').forEach(button => {
            const value = button.dataset.msOptionValue;
            const pressed = options[position] === value;
            button.classList.toggle('selected', pressed);
            button.setAttribute('aria-pressed', String(pressed));
            button.disabled = !variants.some(candidate => candidate.available && candidate.options[position] === value);
          });
        });
        controls.querySelector('[data-ms-variant-price]').textContent = money(variant?.price || selected.price);
        const compare = controls.querySelector('[data-ms-compare-price]');
        compare.hidden = !(variant?.compare_at_price > variant?.price);
        compare.textContent = compare.hidden ? '' : money(variant.compare_at_price);
        controls.querySelector('[data-ms-stock-note]').textContent = variant?.available ? strings.available : strings.soldOut;
        const button = controls.querySelector('[data-ms-add-button]');
        button.disabled = busy || !variant?.available;
        button.querySelector('[data-ms-add-label]').textContent = busy ? strings.updating : variant?.available ? strings.add : strings.soldOut;
        controls.querySelector('[data-ms-product-error]').textContent = '';
        if (updateURL && controls.hasAttribute('data-ms-update-url') && variant) {
          const url = new URL(location.href);
          url.searchParams.set('variant', String(variant.id));
          history.replaceState({}, '', url);
          const mediaId = variant.featured_media?.id;
          const imageId = variant.featured_image?.id;
          const gallery = controls.closest('[data-ms-product-page]')?.querySelector('[data-ms-gallery]');
          if (gallery && (mediaId || imageId)) {
            const target = [...gallery.querySelectorAll('[data-ms-gallery-target]')].find(element => element.dataset.msGalleryTarget === String(mediaId || imageId));
            target?.click();
          }
        }
      };
      if (pickers) {
        pickers.hidden = false;
        controls.querySelector('.ms-variant-fallback').hidden = true;
        pickers.addEventListener('click', event => {
          const button = event.target.closest('[data-ms-option-value]');
          if (!button || button.disabled) return;
          const position = Number(button.closest('[data-ms-option-position]').dataset.msOptionPosition);
          options[position] = button.dataset.msOptionValue;
          const exact = variants.find(variant => variant.available && variant.options.every((value, index) => value === options[index]));
          if (!exact) {
            const available = variants.find(variant => variant.available && variant.options[position] === options[position]);
            if (available) options = [...available.options];
          }
          refresh(true);
        });
      }
      refresh();
    });
  }
  document.addEventListener('click', event => {
    const bagTrigger = event.target.closest('[data-ms-cart-open]');
    if (bagTrigger) { event.preventDefault(); openDialog(drawer); void loadBag(); return; }
    const quickTrigger = event.target.closest('[data-ms-quick-open]');
    if (quickTrigger) { const dialog = document.getElementById(quickTrigger.dataset.msQuickOpen); if (dialog) { event.preventDefault(); openDialog(dialog); } return; }
    const quantityButton = event.target.closest('[data-ms-cart-change]');
    if (quantityButton) { void changeQuantity(quantityButton); return; }
    const galleryButton = event.target.closest('[data-ms-gallery-target]');
    if (galleryButton) {
      const gallery = galleryButton.closest('[data-ms-gallery]');
      gallery.querySelectorAll('[data-ms-gallery-slide]').forEach(slide => {
        slide.hidden = slide.dataset.msGallerySlide !== galleryButton.dataset.msGalleryTarget;
        if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      gallery.querySelectorAll('[data-ms-gallery-target]').forEach(button => button.setAttribute('aria-pressed', String(button === galleryButton)));
      return;
    }
    if (event.target.closest('[data-ms-bag-retry]')) void loadBag();
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-ms-product-form]')) { event.preventDefault(); void addProduct(event.target); }
    if (event.target.matches('[data-ms-discount-form]')) { event.preventDefault(); void applyDiscount(event.target); }
  });
  document.addEventListener('shopify:section:load', event => initializeProducts(event.target));
  window.addEventListener('pageshow', event => { if (event.persisted) void loadBag(); });
  drawer.addEventListener('close', clearArrival);
  initializeProducts();
  renderCart(cart);
})();
